var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("aside", [
    _c("div", { staticClass: "o-albumSidebar" }, [
      _c("img", {
        staticClass: "img-fluid header__logo",
        attrs: {
          src: "assets/img/adoptuj-kravicku-logo.svg",
          alt: "adoptuj-kravicku-logo"
        }
      }),
      _vm._v(" "),
      _c("h3", [_vm._v("Môj album")]),
      _vm._v(" "),
      _c("ul", { staticClass: "m-albumSiebar__menu" }, [
        _c(
          "li",
          [
            _c(
              "router-link",
              {
                staticClass: "a-albumSidebar__item --uspechy",
                attrs: { to: { name: "album-uspechy" } }
              },
              [
                _c("span", { staticClass: "icon --trophy" }),
                _vm._v("Moje úspechy\n                ")
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          [
            _c(
              "router-link",
              {
                staticClass: "a-albumSidebar__item --kravicky",
                attrs: { to: { name: "album-kravicky" } }
              },
              [
                _c("span", { staticClass: "icon --cows" }),
                _vm._v("Kolekcia\n                ")
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          [
            _c(
              "router-link",
              {
                staticClass: "a-albumSidebar__item --anatomia",
                attrs: { to: { name: "album-anatomia" } }
              },
              [
                _c("span", { staticClass: "icon --cowBody" }),
                _vm._v("Anatómia kravičky\n                ")
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          [
            _c(
              "router-link",
              {
                staticClass: "a-albumSidebar__item --recepty",
                attrs: { to: { name: "album-recepty" } }
              },
              [
                _c("span", { staticClass: "icon --recipes" }),
                _vm._v("Mliečne recepty\n                ")
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          [
            _c(
              "router-link",
              {
                staticClass: "a-albumSidebar__item --omalovanky",
                attrs: { to: { name: "album-omalovanky" } }
              },
              [
                _c("span", { staticClass: "icon --omalovanky" }),
                _vm._v("Omaľovánky\n                ")
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          [
            _c(
              "router-link",
              {
                staticClass: "a-albumSidebar__item --videosekcia",
                attrs: { to: { name: "album-videosekcia" } }
              },
              [
                _c("span", { staticClass: "icon --videosekcia" }),
                _vm._v("Kravička TV\n                ")
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("ul", { staticClass: "m-albumSidebar__profileList" }, [
        _vm.profil.pouzivatel_id
          ? _c("li", [
              _vm.profil.pouzivatel_id.farma_pouzivatela.length != 0
                ? _c(
                    "a",
                    {
                      staticClass: "a-albumSidebar__item",
                      attrs: {
                        href:
                          "https://www.adoptujkravicku.sk/hra/farma/moja-farma?" +
                          _vm.profil.pouzivatel_id.id +
                          "&" +
                          _vm.profil.pouzivatel_id.pouzivatel_name +
                          "&" +
                          _vm.profil.pouzivatel_email
                      }
                    },
                    [
                      _c("span", { staticClass: "icon --user" }),
                      _vm._v("Moja farma\n                ")
                    ]
                  )
                : _vm._e()
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "li",
          [
            _c(
              "router-link",
              {
                staticClass: "a-albumSidebar__item",
                attrs: { to: { name: "kravicky" } }
              },
              [
                _c("span", { staticClass: "icon --cows" }),
                _vm._v("Moje kravičky\n                ")
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          [
            _c(
              "router-link",
              {
                staticClass: "a-albumSidebar__item",
                attrs: { to: { name: "profil" } }
              },
              [
                _c("span", { staticClass: "icon --profile" }),
                _vm._v("Môj profil\n                ")
              ]
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _vm._m(0)
    ]),
    _vm._v(" "),
    _vm._m(1)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn --primary d-md-none",
        attrs: { id: "closeAlbumMenu" }
      },
      [_c("span", { staticClass: "icon" })]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "btn --primary d-md-none",
        attrs: { id: "openAlbumMenu" }
      },
      [_c("span", { staticClass: "icon" })]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }